// 20261023 서버 배지와 조회 필터가 같은 토큰 상태 기준을 사용한다.
export const getReportTokenState = (info) => {
    if (info.tokenResetRequestYn === "Y") {
        const reasons = { TOKEN_MISSING: "missing", TOKEN_INVALID: "invalid", TOKEN_UNAUTHORIZED: "mismatch", TOKEN_CONFLICT: "mismatch" };
        return { key: reasons[info.tokenResetReason] || "reset", style: "failed" };
    }
    if (info.reportTokenIssuedYn === "N") return { key: "unissued", style: "unknown" };
    if (info.reportTokenIssuedYn !== "Y") return { key: "unknown", style: "unknown" };
    return info.reportTokenVerifiedDt ? { key: "verified", style: "success" } : { key: "unconfirmed", style: "pending" };
};

// 20261027 배지와 필터는 정상 수집된 정식 RabbitMQ 버전의 MQTT 5 지원 기준을 공유한다.
export const getRabbitmqVersionSupport = (info) => {
    if (!info.rabbitmqInfoEnabled || info.rabbitmqInfoQueryStatus !== "AVAILABLE" || info.rabbitmqLastCheckStatus !== "SUCCESS") return "unknown";
    const match = /^(\d+)\.(\d+)\.(\d+)(?:\+[0-9A-Za-z.-]+)?$/.exec(info.rabbitmqVersion || "");
    if (!match) return "unknown";
    return Number(match[1]) > 3 || (Number(match[1]) === 3 && Number(match[2]) >= 13) ? "supported" : "unsupported";
};

export const defaultLocalServerFilters = { update: "all", token: "all", connection: "all", status: "all", mqtt: "all", type: "all", rabbitmq: "all" };

// 20261023 누락된 상태를 정상이나 미지원으로 추정하지 않고 별도 조회한다.
export const matchesLocalServerFilters = (info, filters) => {
    const token = getReportTokenState(info).key;
    if (filters.update !== "all" && (filters.update === "allowed" ? info.isUpdateAllowed !== true : info.isUpdateAllowed !== false)) return false;
    if (filters.token !== "all" && (filters.token === "recovery" ? !["missing", "invalid", "mismatch", "reset"].includes(token) : token !== filters.token)) return false;
    if (filters.connection !== "all" && info.serverStatus !== filters.connection) return false;
    const rawStatus = String(info.lastUpdateStatus || "UNKNOWN").toUpperCase();
    const status = ["STARTED", "RUNNING", "REBOOT_PENDING"].includes(rawStatus) ? "progress" : ["SUCCESS", "FAILED", "PARTIAL"].includes(rawStatus) ? rawStatus : "unknown";
    if (filters.status !== "all" && status !== filters.status) return false;
    // 20261023 기능 미보고와 명시적인 미지원을 구분한다.
    const mqtt = info.mqttAvailableYn === "Y" ? "Y" : info.capabilityCheckDt && info.mqttAvailableYn === "N" ? "N" : "unknown";
    if (filters.mqtt !== "all" && mqtt !== filters.mqtt) return false;
    if (filters.type !== "all" && (info.localServerType || "UNKNOWN") !== filters.type) return false;
    // 20261027 이전 목록 복원 상태에는 새 키가 없을 수 있으며, 개별 버전 조회는 최근 수집값도 포함한다.
    const rabbitmq = filters.rabbitmq || "all";
    if (rabbitmq !== "all" && (rabbitmq.startsWith("version:")
        ? info.rabbitmqVersion !== rabbitmq.slice("version:".length)
        : getRabbitmqVersionSupport(info) !== rabbitmq)) return false;
    return true;
};
